"use strict";

export var TopBarConstants = {
  CLOSE_USER_MENU: 'CLOSE_USER_MENU',
  CLICK_USER_MENU: 'CLICK_USER_MENU',
  TOP_BAR_SET_TITLE: 'TOP_BAR_SET_TITLE',
  TOP_BAR_SET_DYNAMIC_TOOLBAR: 'TOP_BAR_SET_DYNAMIC_TOOLBAR',
  TOP_BAR_SET_DYN_TB_CONTENT: 'TOP_BAR_SET_DYN_TB_CONTENT'
};